import {
  LOADER_SIZE,
  LOADER_STROKE_WIDTH,
  StyledArc,
  StyledSvg,
} from 'components/Loader/Loader.Styled'

export const Loader = () => {
  return (
    <StyledSvg
      role="status"
      aria-label="Loading"
      viewBox={`0 0 ${LOADER_SIZE} ${LOADER_SIZE}`}
    >
      <StyledArc
        cx={LOADER_SIZE / 2}
        cy={LOADER_SIZE / 2}
        r={(LOADER_SIZE - LOADER_STROKE_WIDTH) / 2}
      />
    </StyledSvg>
  )
}
